module.exports = {"TXTMOB_Feedback":{"id":"TXTMOB_Feedback","defaultMessage":"Visszajelzés"}}